// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5405":"21489d65","6452":"d5175906","6850":"8f3c2eca"}[chunkId] + ".chunk.css";
};